import React, { useState, useEffect } from "react";
import ScrollButton from "../../../../components/scrollbutton/ScrollButton";
import Subheader from "../../../../components/subheader/Subheader";
import { Footer } from "../../../../components/footer/footer";
import firstitem from "../../../../assets/dummy-movie.png";
import { ReactComponent as YourIcon } from "../../../../assets/mdi_calendar.svg";
import { ReactComponent as YourIcon1 } from "../../../../assets/time.svg";
import "./Viewdetails.css";
import { ReactComponent as YourIcon2 } from "../../../../assets/code-compare-solid.svg";
import ViewdetailGraph2 from "./ViewdetailGraph2";
import ViewdetailGraph from "./ViewdetailGraph";
import { ModalTrading } from "./trade/ModalTrading";
import Navbarr from "../../../../components/header/Navbarr";
import { cookieNames } from "../../../../Config/config";
import { imgpath } from "../../../../Config/config";
import {
  leaguedetailsGet,
  livedetailsplayerscGet,
  playermoviesGet,
  weeklyscoresGet,
  weeklyscoresGett,
  templatedetailsGet,
} from "../../../../api/handleapi";
import { Errormsg } from "../../../../components/tostifymsg/Errrormsg";
import { ToastContainer } from "react-toastify";
import { setSecondpmovie } from "../../../../feature/showSlice/secondpmovieSlice";
import { setLoginpmovie } from "../../../../feature/showSlice/loginpmovieSlice";
import { useSelector, useDispatch } from "react-redux";
import { openModal } from "../../../../feature/showSlice/showmodaltradeSlice";
import { openModalmdetails } from "../../../../feature/showSlice/showmodaltrademoviedetailsSlice";
import { useNavigate } from "react-router-dom";
import profileimg1 from "../../../../assets/large profileicon.svg";
import { ModalTradeMoviedetails } from "./trade/ModalTradeMoviedetails";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import { setTrademoviedetailsforid } from "../../../../feature/showSlice/trademoviedetailsforidSlice";
import { useCategory } from "../../../../components/useCategory";
import moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";
import Loader from "../../../../components/loader/Loader";
import {
  reloginMsg,
  nomoviesfound,
  errorstatuscheck,
  awardsummaytext,
} from "../../../../components/language/Language";
import { handle401Error } from "../../../../components/handle401Error";
import Googleadshorizontal from "../../../../components/google-AdSense/Googleadshorizontal";

function MyleagueliveDetailpage() {
  const Navigate = useNavigate();
  const { id } = useParams();
  const Leagueid = id;
  const trademoviedetailsforid = useSelector(
    (state) => state.trademoviedetailsforid,
  );
  const togglestate = useSelector((state) => state.togglestate);
  const secondpusername = Cookies.get("secondpusername");
  const [allplayerweeklyscores, setallPlayerweeklyscores] = useState([]);
  const [playerweeklyscores, setPlayerweeklyscores] = useState([]);
  const [otherplayerweeklyscores, setotherPlayerweeklyscores] = useState([]);
  const [templatename, setTemplatename] = useState();
  const userid = Cookies.get("id");
  const [ldetails, setLdetails] = useState([]);
  const [playersc, setPlayersc] = useState([]);
  const [awardsummary, setawardsummary] = useState([]);
  const [otherplayername, setOtherPlayername] = useState("");
  const dispatch = useDispatch();
  const secondpmovie = useSelector((state) => state.secondpmovie);
  const loginpmovie = useSelector((state) => state.loginpmovie);
  const [showModalswap, setShowModalswap] = useState(false);
  const [showModaldrop, setShowModaldrop] = useState(false);
  const [loading, setLoading] = useState(false);
  const Categoryoptions = useCategory();

  const openModaldrop = () => {
    setShowModaldrop(true);
  };

  const openModalswap = () => {
    setShowModalswap(true);
  };

  const openModalTrading = () => {
    dispatch(openModal(true));
  };

  const openModalMdetails = (movieId) => {
    dispatch(openModalmdetails(true));

    dispatch(setTrademoviedetailsforid(movieId));
  };

  const [isOtherDivOpen, setOtherDivOpen] = useState(false);

  const handleIconClick = () => {
    setOtherDivOpen(!isOtherDivOpen);
  };

  const templateFun = async (templateid) => {
    try {
      const response = await templatedetailsGet(templateid);
      setTemplatename(response?.data?.data?.templateName);
    } catch (error) {
      if (error?.message == errorstatuscheck) {
        await Errormsg(reloginMsg);
        await handle401Error(cookieNames);
        await Navigate("/");
      }
    }
  };

  useEffect(() => {
    const leaguedFun = async (Leagueid) => {
      try {
        setLoading(true);
        const response = await leaguedetailsGet(Leagueid);
        setLdetails(response?.data?.data);
        templateFun(response?.data?.data?.templateTypeId);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error?.message == errorstatuscheck) {
          await Errormsg(reloginMsg);
          await handle401Error(cookieNames);
          await Navigate("/");
        }
      }
    };
    leaguedFun(Leagueid);
  }, [Leagueid]);

  const pweeklyScores = async (Leagueid) => {
    try {
      const response = await weeklyscoresGett(Leagueid);
      if (response?.status === 200) {
        let responseupdate = response?.data?.data?.sort((a, b) => {
          let nameA = a.playerName.toLowerCase();
          let nameB = b.playerName.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        setallPlayerweeklyscores(responseupdate);
      }
    } catch (error) {
      if (error?.message == errorstatuscheck) {
        await Errormsg(reloginMsg);
        await handle401Error(cookieNames);
        await Navigate("/");
      }
    }
  };

  const pweeklyScoress = async (Leagueid, userid) => {
    try {
      const response = await weeklyscoresGet(Leagueid, userid);
      if (response?.status === 200) {
        if (userid == Cookies.get("id")) {
          setPlayerweeklyscores(response?.data?.data[0]?.scores);
        }
      }
    } catch (error) {
      if (error?.message == errorstatuscheck) {
        await Errormsg(reloginMsg);
        await handle401Error(cookieNames);
        await Navigate("/");
      }
    }
  };

  const pweeklyScoresss = async (Leagueid, userid) => {
    try {
      const response = await weeklyscoresGet(Leagueid, userid);
      if (response?.status === 200) {
        setotherPlayerweeklyscores(response?.data?.data[0]?.scores);
      }
    } catch (error) {
      if (error?.message == errorstatuscheck) {
        await Errormsg(reloginMsg);
        await handle401Error(cookieNames);
        await Navigate("/");
      }
    }
  };
  // your original array

  useEffect(() => {
    pweeklyScores(Leagueid);
  }, [Leagueid]);

  useEffect(() => {
    pweeklyScoress(Leagueid, userid);
    pweeklyScoresss(Leagueid, userid);
  }, [Leagueid, userid]);

  useEffect(() => {
    const playerscFun = async (Leagueid) => {
      try {
        const response = await livedetailsplayerscGet(Leagueid);
        setawardsummary(response?.data?.data?.scoreAwardedPlayer);

        let responseLeaguedetails = response?.data?.data?.leagueDetails?.sort(
          (a, b) => {
            let nameA = a.finalScore;
            let nameB = b.finalScore;

            if (nameA < nameB) {
              return 1;
            }
            if (nameA > nameB) {
              return -1;
            }
            return 0;
          },
        );

        console.log("responseLeaguedetails ::", responseLeaguedetails);

        setPlayersc(responseLeaguedetails);
      } catch (error) {
        return;
      }
    };
    playerscFun(Leagueid);
  }, [Leagueid]);

  const movieslistFun = async (Leagueid, userid) => {
    try {
      const response = await playermoviesGet(Leagueid, userid);
      dispatch(
        setLoginpmovie(
          response?.data?.data?.logedInPlayerMovies.sort(
            (a, b) => a.categoryId - b.categoryId,
          ),
        ),
      );
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    movieslistFun(Leagueid, userid);
  }, []);

  const comparemovie = async (Leagueid, suserid, susername) => {
    try {
      const response = await playermoviesGet(Leagueid, suserid);
      if (response?.status === 200) {
        dispatch(
          setSecondpmovie(
            response?.data?.data?.logedInPlayerMovies.sort(
              (a, b) => a.categoryId - b.categoryId,
            ),
          ),
        );
        pweeklyScoress(Leagueid, userid);
        pweeklyScoresss(Leagueid, suserid);

        Cookies.set("secondpusername", susername);
        setOtherPlayername(susername);

        Cookies.set("secondpid", response?.data?.data?.playerId);
        handleIconClick();
      } else {
        Errormsg(nomoviesfound);
      }
    } catch (error) {
      return;
    }
  };

  const noofjoinplayers = playersc?.length;
  const filteredData = playersc?.filter((player) => player?.userId == userid);

  return (
    <div>
      <Navbarr />
      <ToastContainer />
      {togglestate ? (
        <ModalTrading
          Leagueid={Leagueid}
          showModalswap={showModalswap}
          setShowModalswap={setShowModalswap}
          showModaldrop={showModaldrop}
          setShowModaldrop={setShowModaldrop}
          trademdetailsforid={trademoviedetailsforid}
          setTrademdetailsforid={setTrademoviedetailsforid}
        />
      ) : null}
      <ModalTradeMoviedetails
        trademdetailsforid={trademoviedetailsforid}
        setTrademdetailsforid={setTrademoviedetailsforid}
      />
      <div className="after-nav-dsubheader containers con_div">
        <Subheader />
        <div className="detailp-league-card">
          <div className="card d-Cardf">
            <div className="row g-0 main-row ">
              <div className="col-xl-1 col-lg-3 col-md-12 col-sm-12 imag-cardclass">
                <img
                  src={imgpath + ldetails?.image}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = firstitem;
                  }}
                  alt="img"
                  className="detleague-card-img"
                />
              </div>
              <div className="col-xl-11 col-lg-10 col-md-12 col-sm-12">
                <div className="league-card-content content_live">
                  <div className="three_Item_live">
                    <div className="items blockitem">
                      <p className="card-title">{ldetails?.leagueName}</p>
                      <div className="hello">
                        <button className="view_live-btn">LIVE</button>
                      </div>
                      <div className="custom-detail">
                        <h6 className="card-title">{templatename}</h6>
                        <h6 className="card-title">
                          {" "}
                          No of Players: {noofjoinplayers}/{ldetails?.entries}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-20">
                      <a href="##" className="btn btn-primary detail-PP-btn">
                        {ldetails?.visibility}
                      </a>
                    </div>
                    <div className="leaguedatetime2">
                      <div className="dleague-card-tdate">
                        <span>Created:</span>
                        <div className="view_live_time">
                          <YourIcon />
                          <span className="data">
                            {moment
                              .utc(ldetails?.createdDate)
                              .local()
                              .format("dddd, MMMM D, YYYY")}
                          </span>
                        </div>
                        <div className="view_live_time">
                          <YourIcon1 />
                          <span className="time font_time">
                            {moment
                              .utc(ldetails?.createdDate)
                              .local()
                              .format("h:mm a")}
                          </span>
                        </div>
                      </div>
                      <div className="dleague-card-tdate">
                        <span>League End:</span>
                        <div className="view_live_time">
                          <YourIcon />
                          <span className="data">
                            {moment
                              .utc(ldetails?.endDateTime)
                              .local()
                              .format("dddd, MMMM D, YYYY")}
                          </span>
                        </div>
                        <div className="view_live_time">
                          <YourIcon1 />
                          <span className="time font_time">
                            {moment
                              .utc(ldetails?.endDateTime)
                              .local()
                              .format("h:mm a")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="dleague-card-hr" />
            <nav className="dleague-card-nav">
              <p className="cdetail-text-content">{ldetails?.description}</p>
            </nav>
          </div>
        </div>

        <Googleadshorizontal props="pt-2 pb-2 text-center" />
        <div className="row">
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
            <div className="card position_card">
              <nav className="navbar  nav-positionn">My Position</nav>
              <div className="Position_seconddiv ">
                <table className="all_playerlist">
                  <thead>
                    {filteredData?.map((player) => (
                      <tr key={player?.userId}>
                        <td className="itemss your-position">
                          {" "}
                          <img
                            src={imgpath + player?.userImage}
                            className="profileicon "
                            alt="proimg"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = profileimg1;
                            }}
                          />
                        </td>
                        <td className="itemss items-name">
                          {player?.userName?.charAt(0).toUpperCase() +
                            player?.userName?.slice(1)}
                        </td>
                        <td className="score itemss your-position">
                          {player?.finalScore}
                        </td>
                      </tr>
                    ))}
                  </thead>
                </table>
              </div>
            </div>
            <div className="card position_card">
              <nav className="navbar  nav-positionn ">Award Summary</nav>
              <div className="award-table-container">
                {awardsummary?.length > 0 ? (
                  <table className="all_playerlist">
                    <thead>
                      <tr>
                        <td className="itemss profileforsummary">Profile</td>
                        <td className="itemss namesforsummary">Name</td>

                        <td className="itemss">Award</td>

                        <td className="itemss">Award score</td>
                      </tr>
                    </thead>
                    <tbody>
                      {awardsummary?.length > 0
                        ? awardsummary?.map((data, index) => (
                            <tr className="Player_titlee" key={index}>
                              <td className="itemss">
                                <img
                                  src={imgpath + data?.userName?.image}
                                  className="profileicon"
                                  alt="proimg"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = profileimg1;
                                  }}
                                />
                              </td>
                              <td className="itemsss">
                                {data?.userName?.firstName
                                  ?.charAt(0)
                                  .toUpperCase() +
                                  data?.userName?.firstName?.slice(1)}
                              </td>
                              <td className="itemsss">{data?.awardType}</td>
                              <td className="scoree itemsss">{data?.point}</td>
                            </tr>
                          ))
                        : null}
                    </tbody>
                  </table>
                ) : (
                  <span className="d-flex justify-content-center">
                    {awardsummaytext}
                  </span>
                )}
              </div>
            </div>
            <div className="card position_card">
              <nav className="navbar  nav-positionn ">All Players</nav>
              <div className="table-container">
                <table className="all_playerlist">
                  <thead>
                    <tr>
                      <td className="itemss">Rank</td>
                      <td className="itemss">Profile</td>
                      <td className="itemss nameitems">Name</td>
                      <td className="itemss">Score</td>
                      <td className="itemss">Compare</td>
                    </tr>
                  </thead>
                  <tbody>
                    {playersc?.map((data, index) => (
                      <tr className="Player_titlee" key={index}>
                        <td className="itemss">{data?.rank}</td>
                        <td className="itemss">
                          <img
                            src={imgpath + data?.userImage}
                            className="profileicon"
                            alt="proimg"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = profileimg1;
                            }}
                          />
                        </td>
                        <td className="itemsss">
                          {data?.userName?.charAt(0).toUpperCase() +
                            data?.userName?.slice(1)}
                        </td>
                        <td className="scoree itemsss">{data?.finalScore}</td>
                        {data?.userId == userid ? (
                          ""
                        ) : (
                          <td className="campareicons itemsss">
                            <YourIcon2
                              onClick={() =>
                                comparemovie(
                                  data?.leagueId,
                                  data?.userId,
                                  data?.userName,
                                )
                              }
                              className="campareicons"
                            />
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
            <div className="card position_card">
              <nav className="navbar  nav-positionn ">Players Progress</nav>
              <ViewdetailGraph2
                playersc={playersc}
                otherplayername={otherplayername}
                allplayerweeklyscores={allplayerweeklyscores}
                isOtherDivOpen={isOtherDivOpen}
                playerweeklyscores={playerweeklyscores}
                otherplayerweeklyscores={otherplayerweeklyscores}
              />
            </div>
          </div>
        </div>
        <div className="compare_list_div">
          <div className="row">
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
              <div className="heading_live_list">
                <h6>My Movies</h6>
                <div className="dropdown">
                  <button
                    className="btn btn-secondary dropdown-toggle manage_movies-btns"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Manage Roster
                  </button>
                  <div
                    className="dropdown-menu view-details-dropdown items_dropdown_view_details"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <button
                      disabled={isOtherDivOpen == true ? false : true}
                      className="dropdown-item"
                      onClick={openModalTrading}
                    >
                      Trades
                    </button>
                    <a className="dropdown-item" onClick={openModaldrop}>
                      Pickups
                    </a>
                    <a className="dropdown-item" onClick={openModalswap}>
                      Swaps
                    </a>
                  </div>
                </div>
              </div>

              <div className="card position_cardd">
                <div className="table-containerr">
                  <table className="all_playerlist">
                    <thead>
                      <tr className="movieslist_headings">
                        <td className="itemss">Movie</td>
                        <td className="itemss">Category</td>
                        <td className="itemss nameitems">Release Date</td>
                        <td className="itemss">Score</td>
                        <td className="itemss">Production Status</td>
                      </tr>
                    </thead>
                    <tbody>
                      {loginpmovie?.length != 0 ? (
                        loginpmovie?.map((data, index) => (
                          <tr className="Player_title" key={index}>
                            <td
                              className="itemss moviesnamefordetails"
                              onClick={() => openModalMdetails(data?.movieId)}
                            >
                              {data?.movieName?.length > 30
                                ? data?.movieName?.substring(0, 30) + "..."
                                : data?.movieName || "Empty"}
                            </td>
                            <td className="itemss">
                              {
                                Categoryoptions?.find(
                                  (cat) => cat?.id == data?.categoryId,
                                )?.category
                              }
                            </td>
                            <td className="itemsss">
                              {typeof data?.releaseDate !== "undefined" &&
                              moment
                                .utc(data?.releaseDate)
                                .local()
                                .format("MMMM D, YYYY") != "Invalid date"
                                ? moment
                                    .utc(data?.releaseDate)
                                    .local()
                                    .format("MMMM D, YYYY")
                                : "N/A"}
                            </td>

                            <td className="campareicons itemsss">
                              {data?.finalScore || 0}
                            </td>
                            <td className="campareicons itemsss">
                              {" "}
                              {data?.production || "N/A"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <div className="no_movies_found">No Movies found</div>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {isOtherDivOpen && (
              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                <div className="heading_live_list otherplyer_list">
                  <h6>
                    {secondpusername?.charAt(0).toUpperCase() +
                      secondpusername?.slice(1)}
                    's Movies
                  </h6>
                </div>
                <div className="card position_card">
                  <div className="table-containerr">
                    <table className="all_playerlist">
                      <thead>
                        <tr className="movieslist_headings">
                          <td className="itemss">Movie</td>
                          <td className="itemss">Category</td>
                          <td className="itemss nameitems">Release Date</td>

                          <td className="itemss">Score</td>
                          <td className="itemss">Production Status</td>
                        </tr>
                      </thead>
                      <tbody>
                        {secondpmovie?.length != 0 ? (
                          secondpmovie?.map((data, index) => (
                            <tr className="Player_title" key={index}>
                              <td
                                className="itemss moviesnamefordetails"
                                onClick={() => openModalMdetails(data?.movieId)}
                              >
                                {data?.movieName?.length > 30
                                  ? data?.movieName?.substring(0, 30) + "..."
                                  : data?.movieName || "Empty"}
                              </td>
                              <td className="itemss">
                                {
                                  Categoryoptions?.find(
                                    (cat) => cat?.id == data?.categoryId,
                                  )?.category
                                }
                              </td>
                              <td className="itemsss">
                                {typeof data?.releaseDate !== "undefined" &&
                                moment
                                  .utc(data?.releaseDate)
                                  .local()
                                  .format("MMMM D, YYYY") != "Invalid date"
                                  ? moment
                                      .utc(data?.releaseDate)
                                      .local()
                                      .format("MMMM D, YYYY")
                                  : "N/A"}
                              </td>

                              <td className="campareicons itemsss">
                                {data?.finalScore || 0}
                              </td>
                              <td className="campareicons itemsss">
                                {" "}
                                {data?.production || "N/A"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <div className="no_movies_found">No Movies found</div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
      {loading ? <Loader /> : null}
      <ScrollButton />
    </div>
  );
}

export default MyleagueliveDetailpage;
